import { ProtectedEquipmentOrgTreeNode } from './protected-equipment-orgtreenode';

export class ProtectedEquipment {
  protectedEquipmentId: string;
  isActive: boolean;
  protectedDate: string;
  unprotectedDate: string;
  equipmentId: string;
  equipment: ProtectedEquipmentOrgTreeNode = new ProtectedEquipmentOrgTreeNode();
  parentLocation: ProtectedEquipmentOrgTreeNode = new ProtectedEquipmentOrgTreeNode();
  protectingLocationId: string;
  protectingLocationOrgTreeNodeId: string;
  protectingLocationOrgTreeNodeName: string;
  rowIndex: number;

  public json(): any {
    return this;
  }

  public loadFromJson(data) {
    this.protectedEquipmentId = data.protectedEquipmentId;
    this.isActive = data.isActive;
    this.protectedDate = data.protectedDate;
    this.unprotectedDate = data.unprotectedDate;
    this.equipmentId = data.equipmentId;
    this.rowIndex = data.rowIndex;

    if (data.equipment) {
      this.equipment = new ProtectedEquipmentOrgTreeNode();
      this.equipment.loadFromJson(data.equipment);
    }

    if (data.parentLocation) {
      this.parentLocation = new ProtectedEquipmentOrgTreeNode();
      this.parentLocation.loadFromJson(data.parentLocation);
    }

    this.protectingLocationId = data.protectingLocationId;
    this.protectingLocationOrgTreeNodeId = data.protectingLocationOrgTreeNodeId;
    this.protectingLocationOrgTreeNodeName = data.protectingLocationOrgTreeNodeName;
  }
}
